import React from 'react';
import { Footer } from '../Components/Footer/Footer.js';
import './PageShowcase.css';

const posts = [
  {
    title: 'How I approach responsive navigation design',
    summary: 'A practical checklist for designing mobile menus that are fast, readable and easy to close.',
    date: 'August 2026',
  },
  {
    title: 'Structuring React components for maintainability',
    summary: 'Simple patterns that reduce duplication and help features scale without messy rewrites.',
    date: 'July 2026',
  },
  {
    title: 'Color systems for personal portfolio websites',
    summary: 'How to pick a palette with enough contrast and character without overwhelming content.',
    date: 'June 2026',
  },
];

export const BlogPage = () => {
  return (
    <>
      <main className="page-shell">
        <section className="page-content">
          <div className="page-hero">
            <span className="page-kicker">Notes & Articles</span>
            <h1>Development insights and build notes</h1>
            <p>
              I use this space to share implementation decisions, trade-offs and lessons learned from shipping
              front-end and full-stack projects.
            </p>
          </div>

          <div className="page-grid">
            {posts.map((post) => (
              <article className="page-card" key={post.title}>
                <h3>{post.title}</h3>
                <p>{post.summary}</p>
                <p className="page-meta">{post.date}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};
